import { FC } from 'react';
import { UserShape } from 'models/users';
import { PenShape } from 'models/pens';
import { PenAlertData } from 'components/Pens/List/Customer/CustomerPenList';
import { MobileTableProps } from '../MobileTable';
import { ChevronRight as ArrowIcon } from '@mui/icons-material';
import './MobileTableRow.scss';
import { HoleDectionListItem } from 'models/holeDetection';

export type TableRowProps =
  | UserShape
  | PenShape
  | PenAlertData
  | HoleDectionListItem;

type ExcludedProps = 'tableProps' | 'data';

type Props = Omit<MobileTableProps, ExcludedProps> & {
  row: TableRowProps;
};

const MobileTableRow: FC<Props> = ({
  mobileBottomColumn,
  mobileMainContent,
  onRowClick,
  row,
}) => {
  return (
    <div className="table-row">
      <div className="content">{mobileMainContent(row)}</div>

      <div className="footer">
        <div className="footer-left">{mobileBottomColumn(row)}</div>

        {onRowClick && <ArrowIcon sx={{ color: '#005EC2' }} />}
      </div>
    </div>
  );
};

export default MobileTableRow;
